exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd[data-v-8602d532] {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;       \n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n}\n.custom-select-sm-alt[data-v-8602d532] {\n    background-color: #e9ecef;\n    padding-top: 0;\n    padding-left: 0;\n    padding-bottom: 0;\n      height: calc(1.5em + 2px);\n}\n.list-group-scroll[data-v-8602d532] {\n    max-height: 500px; \n    overflow: scroll; \n    -webkit-overflow-scrolling: touch;\n}    \n", ""]);

// exports
